import { jsonb, pgTable, text, varchar } from 'drizzle-orm/pg-core';
import { id, timestamps } from './_shared';

export const interviewSessions = pgTable('interview_sessions', {
  id: id(),
  userId: text('user_id').notNull(),
  jobId: text('job_id'),
  applicationId: text('application_id'),
  sessionType: varchar('session_type', { length: 24 }).notNull(),
  elevenlabsSessionId: varchar('elevenlabs_session_id', { length: 128 }),
  voicePresetId: varchar('voice_preset_id', { length: 64 }),
  transcript: jsonb('transcript'),
  starScores: jsonb('star_scores'),
  feedback: text('feedback'),
  ...timestamps,
});

export const prepPacks = pgTable('prep_packs', {
  id: id(),
  userId: text('user_id').notNull(),
  company: varchar('company', { length: 200 }).notNull(),
  newsSummary: text('news_summary'),
  engBlogDigest: text('eng_blog_digest'),
  leadershipIntel: jsonb('leadership_intel'),
  hiringLoopShape: jsonb('hiring_loop_shape'),
  culturalAxis: jsonb('cultural_axis'),
  workSampleExemplars: jsonb('work_sample_exemplars'),
  refreshedAt: jsonb('refreshed_at'),
  ...timestamps,
});

export const starRecallLog = pgTable('star_recall_log', {
  id: id(),
  userId: text('user_id').notNull(),
  prompt: text('prompt').notNull(),
  retrievedAchievementIds: jsonb('retrieved_achievement_ids').$type<string[]>(),
  finalAnswer: text('final_answer'),
  durationMs: jsonb('duration_ms'),
  ...timestamps,
});
